import { useState, useCallback }              from 'react';
import { useDispatch }                        from 'react-redux';
import CookieUtil                             from "../utils/cookieUtil";
import setStorageItems                        from '../utils/storageUtil';
import { fetchEventData,fetchEventLanguage }  from '../api/eventApi';
import _                                      from "lodash";
import { IMAGES_BASE_PATH }                   from '../config/constants';
import { setEventData as setEventDataAction } from '../store/Actions/Event/eventActions';

const useEventData = () => {
  const [eventData, setEventData] = useState(null);
  const dispatch      = useDispatch();

  const loadEventData = useCallback(async () => {
    
    const user:any      = CookieUtil.getCookie('user_info');
    const userId        = user ? user._id : 0;
    const token         = CookieUtil.getToken();
 

    try {
      const data = await fetchEventData(userId, token);
      if (data.data?. _id) {
        const languages:any = await fetchEventLanguage(data.data._id);


        setEventData({
          ...data.data,
          language: languages
        });
        dispatch(setEventDataAction({
          ...data.data,
          language: languages
        })); // Dispatch data to the store
        // Storing Data in Storage
        storeLocalStorageEventData(data.data);
        storeCookiesEventData(data.data, languages);

      }// End of If check
      
    } catch (error) {
      console.error('Failed to fetch event data', error);
    }
  }, []);


  

// function that stores local data
const storeLocalStorageEventData = (data: any) => {

  setStorageItems([
    { key: 'event_company_email',   value: data.event_company_email, storageType: 'sessionStorage' },
    { key: 'event_description',     value: data.title },
    { key: 'event_title',           value: data.description },
    { key: 'schedule_days',         value: data.schedule_days },
    { key: 'primaryLandingColor',   value: data.primary_landing_color },
    { key: 'primaryColor',          value: data.primary_color },
    { key: 'menuTextColor',         value: data.menu_text_color },
    { key: 'counterBackgroundColor',value: data.counter_background_color },
    { key: 'commonColor',           value: data.common_color },
    { key: 'registerButtonColor',   value: data.register_button_color },
    { key: 'scheduleBoxColor',      value: data.theme_schedule_box_color },
    { key: 'headerColor',           value: data.theme_header_color },
    { key: 'footerColor',           value: data.theme_footer_color },
    { key: 'backgroundColor',       value: data.theme_background_color },
    { key: 'boothBoxColor',         value: data.theme_booth_box_color },
  ]);
  if (!localStorage.getItem('data_loaded')) {
    localStorage.setItem("data_loaded", "1");
  }
};

const storeCookiesEventData = (data: any, languages:any) => {

  CookieUtil.setCookie("is_paid", data.is_paid)
 const has_lang_installed = _.find(languages, o => o.language_id._id === CookieUtil.getCookie("language_id") && o.language_id.language === CookieUtil.getCookie("lang_name"));

  
  if (!has_lang_installed) {
    const lang = _.find(languages, o => o._id === data.lang_id);
    const lang_name = _.get(lang, 'language_id.language', '');
    console.log("Langauge Svng first time===>",lang_name);
    CookieUtil.setCookie("language_id", lang._id);
    CookieUtil.setCookie("lang_name", lang_name);
  }

  CookieUtil.setCookie("is_sandbox", data.is_sandbox)
  CookieUtil.setCookie("sandbox_paypal_app_id", data.paypal_app_id)
  CookieUtil.setCookie("paypal_production_app_id", data.paypal_production_app_id)
  CookieUtil.setCookie("push_noti_api", data.push_noti_api)
  CookieUtil.setCookie("safari_push_api", data.safari_push_id)
  CookieUtil.setCookie("event_name", data.title)

  if (data.WpaIcon) {
    let file_name = data.WpaIcon.file_name;
    CookieUtil.setCookie("icon_152", IMAGES_BASE_PATH + data.WpaIcon._id + '/' + file_name)

  } else {
    CookieUtil.setCookie("icon_152", 'https://website-dec.avianetvep.com/assets/fav-icons/aviareps_152x152.png')
  }
  if (data.event_domain) {
    let event_domain = data.event_domain;

    if (event_domain.includes("http")) {
      CookieUtil.setCookie("start_url", event_domain + '/login')
      CookieUtil.setCookie("start_url", event_domain)
    } else {
      CookieUtil.setCookie("start_url", 'https://' + event_domain + '.avianetvep.com/login')
      CookieUtil.setCookie("scope", 'https://' + event_domain + '.avianetvep.com')
    }

  }

  CookieUtil.setCookie("event_city", data.event_city);
  CookieUtil.setCookie("event_address", data.event_address);
  CookieUtil.setCookie("event_company_address", data.event_company_location);
  CookieUtil.setCookie("event_id", data._id);
  CookieUtil.setCookie("selected_plan", '');


};


return { eventData, loadEventData };
};

export default useEventData;
